var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconThumbDownFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14H6V3H3V14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 21H13.5303C12.5383 21 11.6689 20.336 11.4079 19.3789L10.7967 17.1378C10.4282 15.7866 9.35874 14.7397 8 14.4V3.4H15.8263C17.7693 3.4 19.4824 4.67454 20.0407 6.53567L21.5504 11.5678C21.9738 12.9794 20.9168 14.4 19.4431 14.4H17.35C16.7425 14.4 16.25 14.8925 16.25 15.5V19.9C16.25 20.5075 15.7575 21 15.15 21Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconThumbDownFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconThumbDownFilled.a478d4a21354e36a30b44425f04a2286.svg";